module.exports = __webpack_public_path__ + "img/s1-v2.4811f7f3.png";